export interface Crosspost {
  destinationId: string;
  destinationName: string;
  type?: string;
}

// TODO: Crosspost and CrosspostGet need a deeper dive to match backend definitions vs use case in Studio
export type CrosspostGet = {
  destinationId: string;
  destinationName?: string;
  type?: string;
};

export type DestinationDetails = {
  id: string;
  privacyOptions?: Array<string>;
  tiktok?: TikTokDestinationInfo;
  title: string;
  type: string;
};

/** `tiktok` block of `GET /socialmedia/@channelId/destinations`; creator fields are null when `canPost` is false */
export type TikTokDestinationInfo = {
  canPost: boolean;
  canPostReason: string | null;
  commentDisabled: boolean | null;
  creatorAvatarUrl: string | null;
  creatorNickname: string | null;
  duetDisabled: boolean | null;
  maxVideoPostDurationSec: number | null;
  stitchDisabled: boolean | null;
};

export interface UploadPOSTUrls {
  downloadUrl: string;
  filePath?: string;
  uploadUrl: string;
}

export const FACEBOOK_DESTINATION_TYPES = {
  PAGE: 'fb_page',
  TIMELINE: 'fb_timeline',
  GROUP: 'fb_group',
};

export interface DestinationOption {
  label: string;
  value: DestinationDetails;
}

export interface ChannelDetails {
  analyticDataCollection: boolean;
  customerId: string;
  description: string;
  name: string;
  partnerChannelId: string;
  type: string;
  userId: string | null;
  uuid: string;
  viewUrl: string;
}
